import React from "react";
import Link from "next/link";
import { useTranslations } from '../../locales/useTranslations';
import { BiSolidEnvelope } from "react-icons/bi";

const AppDevelopmentHeader = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="mainbanner">
        <div className="app-development-banner">
          <div className="container">
            <div className="app-development-banner-content">
              <h1
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1200"
              >
                {t('appDevelopment_header_title1')}
                <br />
                <span>{t('appDevelopment_header_title2')}</span>
                <br />
                {t('appDevelopment_header_title3')}
              </h1>

              <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1200">
                {t('appDevelopment_header_description')}
              </p>

              <div
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="1200"
              >
                <Link href="/kontakt" className="default-btn">
                  <BiSolidEnvelope />{t('appDevelopment_header_cta')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppDevelopmentHeader;
